import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const SidebarContainer = styled.div`
  width: 250px; 
  min-width: 250px; 
  max-width: 250px; 
  padding: 20px;
  background-color: #f4f4f4;
  height: 100vh;
  position: relative;
  top: 0;
  left: 0;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  overflow-y: auto; 

  @media (max-width: 768px) {
    height: auto; 
  }
`;

export const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const NavItem = styled.li`
  margin-bottom: 20px;
`;

export const MenuItem = styled.div`
  display: flex;
  justify-content: space-between;
  text-align: start;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  padding: 5px 0;
  
  span {
    flex: 1;
  }
  &:hover {
    color: #ff0000;
  }
`;

export const SubFilterMenu = styled.ul`
  list-style: none;
  padding-left: 30px; 
  margin: 5px 0 10px 0;
`;


export const ToggleIcon = styled.img`
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

export const SubMenu = styled.ul`
  list-style: none;
  padding-left: 20px;
  text-align: start;
  margin: 0;
`;

export const SubMenuLink = styled(Link)`
  display: block;
  padding: 5px 0;
  color: #333;
  text-decoration: none;
  font-size: 14px;

  &:hover {
    color: #ff0000;
  }
`;
